<template>

    <div class="container-fluid flash-messages" v-if="$page.props.flash">

        <div class="alert alert-success alert-dismissible fade show mt-3" role="alert" v-if="$page.props.flash.success">
            <div class="d-flex align-items-center">
                <!--<i class="bi bi-emoji-smile fs-4"></i>-->
                <span v-html="$page.props.flash.success" class="ms-2"></span>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>

        <div class="alert alert-danger alert-dismissible fade show mt-3" role="alert" v-if="$page.props.flash.error">
            <div class="d-flex align-items-center">
                <i class="bi bi-exclamation-circle-fill fs-4"></i>
                <span v-html="$page.props.flash.error" class="ms-2"></span>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>

        <div class="alert alert-warning alert-dismissible fade show mt-3" role="alert" v-if="$page.props.flash.message">
            <div class="d-flex align-items-center">
                <i class="bi bi-info-circle fs-4"></i>
                <span v-html="$page.props.flash.message" class="ms-2"></span>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>

        <div class="alert alert-info alert-dismissible fade show mt-3" role="alert" v-if="$page.props.flash.content">
            <span v-html="$page.props.flash.content"></span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>

    </div>

</template>


<script>
    export default {
        props: {
        },
        data() {
            return {

            }
        }
    }
</script>